import { useState } from "react";
import ColourSwatch from "../colour-swatch/colour-swatch";
import { useStoreState } from "../../store/data-store";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InventoryModal from "../inventory-modal/inventory-modal";
import { Inventory } from "../../data-models/inventory";

const InventoryPage = () => {

    const newInventory : Inventory = {
        id: 0,
        userId: '',
        colourNumber: '',
        meters: 0
    }

    const [showModal, setModal] = useState(false);
    const [editableInventory, setInventory] = useState(newInventory)

    const inventory = useStoreState(store => store.inventory);

    const addInventory = () => {
        setInventory(newInventory);
        setModal(true);
    }
    const editInventory = (colourId:number) => {
        const selectedColour = inventory.find(x => x.id === colourId);
        setInventory(selectedColour!);
        setModal(true);
    }


    const closeModal = () => {
        setModal(false);
    }


    return (
        <div className="page-section">
            <div className="section-title">Inventory Page</div>
            { showModal && <InventoryModal closeModal={closeModal} inventory={editableInventory}/>}
            <div className="data-section inventory-section">
                <div>Add&nbsp;&nbsp;<FontAwesomeIcon icon="add" onClick={addInventory}/></div>
                <table>
                    <thead>
                    <tr>
                        <th></th>
                        <th className="col-colour-number">#</th>
                        <th className="col-colour-name">Colour</th>
                        <th className="col-meters">Meters</th>
                        <th className="col-meters">Assigned</th>
                        <th className="col-bobbin">Bobbin</th>
                    </tr>
                    </thead>
                    <tbody>
                {
                    inventory.sort((a,b) => { 
                        if( isNaN(a.colourNumber as any) || isNaN(b.colourNumber as any))
                        {
                            if( a.colourNumber > b.colourNumber)
                                return 1;
                            else   
                                return -1;
                        }
                        else {
                            if( Number(a.colourNumber) > Number(b.colourNumber))
                                return 1;
                            else    
                                return -1;
                        }}
                        ).map((t,idx) => {
                        return (
                          <tr key={idx}>
                            <td><ColourSwatch rgb={t.rgb}/></td>
                            <td className='functional-link' onClick={() => editInventory(t.id)} >{t.colourNumber}</td>
                            <td>{t.colourName}</td>
                            <td>{t.meters}</td>
                            <td>{t.assignedMeters}</td>
                            <td><input type="checkbox" readOnly checked={t.isOnBobbin}/></td>
                          </tr>
                        );
                    })
                }
                </tbody>
                </table>
            </div>
        </div>
    )

}
export default InventoryPage;